var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.299 25.9945H18.299C24.1323 25.9945 26.4657 23.6611 26.4657 17.8278V10.8278C26.4657 4.99447 24.1323 2.66113 18.299 2.66113H11.299C5.46566 2.66113 3.13232 4.99447 3.13232 10.8278V17.8278C3.13232 23.6611 5.46566 25.9945 11.299 25.9945Z",
    stroke: "#1761BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2987 11.9948C12.5873 11.9948 13.632 10.9501 13.632 9.66146C13.632 8.37279 12.5873 7.32812 11.2987 7.32812C10.01 7.32812 8.96533 8.37279 8.96533 9.66146C8.96533 10.9501 10.01 11.9948 11.2987 11.9948Z",
    stroke: "#1761BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91406 22.4364L9.66573 18.5748C10.5874 17.9564 11.9174 18.0264 12.7457 18.7381L13.1307 19.0764C14.0407 19.8581 15.5107 19.8581 16.4207 19.0764L21.2741 14.9114C22.1841 14.1298 23.6541 14.1298 24.5641 14.9114L26.4657 16.5448",
    stroke: "#1761BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/Upload_Image.38a50912e643f22be71b769d67597e4e.svg";
export { ForwardRef as ReactComponent };